module.exports = __webpack_public_path__ + "fonts/Inter-700-vietnamese50.74fe938.woff2";